
import * as preact from "preact";
import { $$ } from "../../Core/Common";
import { $$requestManager } from "../../Core/RequestManager";
import { AutoCompleteGroup } from "../../Common/AutoCompleteGroup/AutoCompleteGroup";
import { CheckBox } from "../../Common/CheckBox/CheckBox";
import { DataPanel, IDataPanelProps } from "../../Common/DataPanel/DataPanel";
import { FlexDate } from "../../Common/FlexDate/FlexDate";
import { LinkSelector } from "../../Common/LinkSelector/LinkSelector";
import { TextBox } from "../../Common/TextBox/TextBox";
import { LocationSelector } from "../../Common/LocationSelector/LocationSelector";
import { VideoSelector } from "../../Common/VideoSelector/VideoSelector";
import { ContentEditor } from "../ContentEditor/ContentEditor";
import { TopicEditor } from "../TopicEditor/TopicEditor";

import EventInstance = EventLibrary.Model.EventInstance;

export interface IEventEditorProps extends IDataPanelProps<EventInstance>
{
    Simple?: boolean;
    onCancel?: Function;
    onSave?: Function;
}

export class EventEditor extends DataPanel<EventInstance, IEventEditorProps>
{
    private _chkPublish: CheckBox;
    private _flexDateStart: FlexDate;
    private _pnlDuplicates: HTMLElement;
    private _txtTeaser: TextBox;
    private _txtTitle: TextBox;
    private _linkSelector: LinkSelector;

    constructor(props: IEventEditorProps)
    {
        super(props);
        this.addDataProperty("Id");
    }

    private _handleSaveClick()
    {
        $$requestManager.execute("api/event/Save", this.getData(), this._onSaveSuccess.bind(this));
    }

    private _onSaveSuccess()
    {
        this.clearData();
        if (this.props.onSave)
        {
            this.props.onSave();
        }
    }

    private _handleClearClick()
    {
        this.clearData();
    }

    private _onStartChange()
    {
        let flexDate = this._flexDateStart.getValue();
        if (flexDate)
        {
            flexDate.RawHours = 0;
            flexDate.RawMinutes = 0;
            flexDate.RawSeconds = 0;

            let endFlexDate = {} as any;
            Object.assign(endFlexDate, flexDate);
            endFlexDate.RawHours = 23;
            endFlexDate.RawMinutes = 59;
            endFlexDate.RawSeconds = 59;

            $$requestManager.execute("api/event/LoadAdminList", {
                Start: flexDate,
                End: endFlexDate
            }, this._onLoadDuplicateSuccess.bind(this), null, true);
        }
    }

    private _onLoadDuplicateSuccess(events)
    {
        let html = "";
        if (events)
        {
            for (let evt of events)
            {
                html += `<div style="padding:4px;"><a target="_blank" href="EventManager?id=${evt.Id}">` + evt.Name + "</a></div>";
            }
        }

        if (html)
        {
            html = "<div style='font-size:14px; font-weight: bold; font-color:#555'>Other Events on this Date / Duplicates?</div>" + html;
            $$.show(this._pnlDuplicates);
        }
        else
        {
            $$.hide(this._pnlDuplicates);
        }

        this._pnlDuplicates.innerHTML = html;

    }

    private _onTeaserGenClick(): void
    {
        let data = this.getData();
        $$requestManager.execute("api/event/GenerateTeaser", { Title: this._txtTitle.getValue(), Details: data.Details }, this._onGenerateTeaser.bind(this), null, true);
    }

    private _onGenerateTeaser(teaser: string): void
    {
        this._txtTeaser.setValue(teaser);
    }

    private _onContentPaste(html: string)
    {
        if (this._linkSelector)
        {
            let regex = /href\s*=\s*"([^"]+wikipedia.org[^"]*)#cite/i;
            let match = html.match(regex);
            if (match)
            {
                let wikiLink = match[1];
                let links = this._linkSelector.getData();
                let alreadyExists = false;
                for (let link of links)
                {
                    if (link.Url.toLowerCase() == wikiLink.toLowerCase())
                    {
                        alreadyExists = true;
                        break;
                    }
                }

                if (!alreadyExists)
                {
                    this._linkSelector.addLink({ Url: wikiLink, Description: "Copied from" });
                }
            }
        }
    }

    public override setData(data?: EventInstance)
    {
        if (this._chkPublish)
        {
            $$.display(this._chkPublish.Container, !data?.IsPublished);
        }
        if (this._pnlDuplicates)
        {
            $$.hide(this._pnlDuplicates);
        }

        super.setData(data);
    }

    public override getData(data?): EventInstance
    {
        data = super.getData(data);
        if (!data.Start)
        {
            return null;
        }

        return data;
    }

    public override focus()
    {
        this._txtTitle.focus();
    }

    public render()
    {
        return (<div ref={(ref) => this._registerContainer(ref)} style={{ display: "flex" }}>
            <div style={{ flex: "1" }}>
                {
                    this.props.Simple ? null : (

                        <div className="formElement">
                            <TextBox Descriptor="Title" ref={(ref) => { this.addDataControl(ref, "Name"); this._txtTitle = ref; }} style={{ width: "550px" }} /><br />
                        </div>
                    )}


                <div className="formElement">
                    <FlexDate Descriptor="Start/When" ref={(ref) => { this.addDataControl(ref, "Start"); this._flexDateStart = ref; }} onChange={this._onStartChange.bind(this)} />
                </div>

                {
                    this.props.Simple ? null : (

                        <div className="formElement">
                            <FlexDate Descriptor="End (optional)" ref={(ref) => this.addDataControl(ref, "End")} />
                        </div>
                    )
                }

                <div className="formElement">
                    <LocationSelector Descriptor="Location" Simple={this.props.Simple} ref={(ref) => this.addDataPanel(ref, "Location")} style={{ width: this.props.Simple ? "400px" : "550px" }} />
                </div>


                {
                    this.props.Simple ? null : (
                        <div>
                            <div className="formElement">
                                <AutoCompleteGroup
                                    Descriptor="Actors"
                                    ref={(ref) => this.addDataControl(ref, "Actors", "ActorIds", null, true)}
                                    Context="1"
                                    CreateComponent={TopicEditor}
                                    CreateData={{TopicType: 1}}
                                    LookupService="api/event/GetTopics"
                                    LoadRecordService="api/event/LoadTopic" />
                            </div>

                            <div className="formElement">
                                <AutoCompleteGroup
                                    Descriptor="Topics"
                                    ref={(ref) => this.addDataControl(ref, "Topics", "TopicIds", null, true)}
                                    Context="0"
                                    CreateComponent={TopicEditor}
                                    CreateData={{TopicType: 0}}
                                    LookupService="api/event/GetTopics"
                                    LoadRecordService="api/event/LoadTopic" />
                            </div>
                        </div>

                    )
                }

                {
                    /*
                    this.props.Simple ? null : (
                        <div className="formElement">
                            <AutoCompleteGroup
                                Descriptor="Organizations"
                                ref={(ref) => this.addDataControl(ref, "Organizations", "OrganizationIds", null, true)}
                                CreateComponent="OrganizationEditor"
                                LoadService="OrganizationService.GetOrganizations"
                                LoadRecordService="OrganizationService.Load"
                                SaveRecordService="OrganizationService.Save" />
                        </div>
                    )
                    */
                }


                {
                    this.props.Simple ? null : (
                        <div>
                            <div className="formElement">
                                <ContentEditor Descriptor="Details" ref={(ref) => { this.addDataPanel(ref); }} OnPaste={this._onContentPaste.bind(this)} />
                            </div>
                            <div className="formElement">
                                <TextBox Descriptor="Teaser" ref={(ref) => { this._txtTeaser = ref; this.addDataControl(ref, "Teaser"); }} style={{ width: "452px" }} />
                                <input type="button" class="ai" value="Generate" onClick={this._onTeaserGenClick.bind(this) }></input>

                            </div>
                        </div>

                    )}

                {
                    this.props.Simple ? null : (

                        <div className="formElement" style={{ width: "562px" }}>
                            <LinkSelector ref={(ref) => { this.addDataPanel(ref, "Links"); this._linkSelector = ref; }} style={{ paddingTop: "5px" }} />
                            <VideoSelector ref={(ref) => { this.addDataPanel(ref, "Videos") }} style={{ paddingTop: "25px" }} />
                        </div>

                    )}


                {this.props.Simple ? null : (<div>
                    <div style={{ marginTop: "30px" }}>
                        <CheckBox text="Publish?" ref={(ref) => { this.addDataControl(ref, "IsPublished"); this._chkPublish = ref; }} style={{ marginRight: "16px", fontSize: "18px" }} size="18px" />
                        <input type="button" onClick={this._handleSaveClick.bind(this)} value="Save" />&nbsp;&nbsp;
                        <input type="button" onClick={this._handleClearClick.bind(this)} value="Clear" />&nbsp;&nbsp;
                        <input type="button" onClick={this.props.onCancel as any} value="Cancel" />
                    </div>
                </div>)}

            </div>
            {this.props.Simple ? null : (<div style={{ flex: "300px" }}><div ref={(ref) => this._pnlDuplicates = ref} className="duplicateEvents" style={{ display: "none" }}></div></div>)}
        </div>
        );
    }
}